import { writable } from 'svelte/store';
import { isSameComponent } from './Component';
import { getEditorModules } from './modules';
import Reactivity from './reactivity';
const { update, subscribe, set } = writable({
    initialized: false,
    active: false,
    rootComponent: null,
    activeComponent: null,
    activeMoveable: null,
    activeModules: [],
    stylebarActive: false,
    stylebarComponents: [],
    popoverComponent: null,
    activePopoverLabel: 'Quick Edit',
    components: [],
    elements: [],
    history: [],
    editting: false,
    highlightedElement: null
});
let previousSeekTime = 0;
const actions = {
    trigger: () => update(state => ({ ...state })),
    activate(toggle) {
        if (toggle !== undefined) {
            update(state => ({ ...state, active: toggle }));
        }
        else {
            update(state => ({ ...state, active: !state.active }));
        }
    },
    clearHistory: () => update(store => ({ ...store, history: [] })),
    setRootComponent: (component) => update(state => ({ ...state, rootComponent: component })),
    highlightElement: (component) => update(state => {
        if (state.highlightedElement)
            state.highlightedElement.classList.remove('highlighted-element');
        if (component)
            component.classList.add('highlighted-element');
        return { ...state, highlightedElement: component };
    }),
    setActiveComponent: (component, e, updates) => update(state => {
        if (state.activeComponent == component)
            return state;
        if (state.activeMoveable)
            Reactivity.makeUnreactive(state.activeMoveable);
        if (state.activeComponent) {
            const modules = state.active ? getEditorModules(state.activeComponent) : [];
            modules.forEach(module => {
                if (module.onUnfocus && state.activeComponent)
                    module.onUnfocus(state.activeComponent);
            });
        }
        if (!component)
            return {
                ...state,
                activeModules: [],
                activeMoveable: null,
                activeComponent: null,
                editting: false,
                popoverComponent: null
            };
        const activeMoveable = Reactivity.makeReactive(component, e);
        const activeModules = state.active ? getEditorModules(component) : [];
        activeModules.forEach(module => {
            if (module.onFocus && component)
                module.onFocus(component);
        });
        let popoverComponent = state.activeComponent && isSameComponent(state.activeComponent, component)
            ? state.popoverComponent
            : !state.activeComponent
                ? state.popoverComponent
                : null;
        if (updates?.popoverComponent)
            popoverComponent = updates.popoverComponent;
        return { ...state, ...updates, activeMoveable, activeComponent: component, activeModules, popoverComponent };
    }),
    toggleStylebar: (toggleState) => update(state => {
        const styleState = toggleState === undefined ? !state.stylebarActive : toggleState;
        return { ...state, stylebarComponents: [], stylebarActive: styleState };
    }),
    setComponents: (components) => update(state => ({ ...state, components })),
    addComponent: (component) => update(state => ({ ...state, components: [...state.components, component] })),
    setPopoverComponent: (component, label) => update(state => ({ ...state, popoverComponent: component, activePopoverLabel: label })),
    removePopoverComponent: (label) => update(state => ({ ...state, popoverComponent: null, activePopoverLabel: label })),
    addStyleComponent: (component, prepend = false) => update(state => ({
        ...state,
        stylebarComponents: prepend ? [component, ...state.stylebarComponents] : [...state.stylebarComponents, component]
    })),
    setStyleComponents: (components) => update(state => ({ ...state, stylebarComponents: components }))
};
export default {
    update,
    subscribe,
    ...actions
};
